if (!customElements.get('inline-svg')) {
	class InlineSvg extends HTMLElement {
		constructor() {
			super();
			// Onload replace this element with the SVG content from the src attribute
			// document.addEventListener("DOMContentLoaded", () => {
				this.init();
			// });
		}


		init() {
			const fetchAndReplaceSvg = async (img) => {
				const classList = this.getAttribute("class");
				const res = await fetch(img.getAttribute("src"));
				let svg = await res.text();

				// Add class to SVG
				if (classList) {
					svg = svg.replace("<svg", `<svg class="${classList}"`);
				}

				// Scope all IDs to this instance to avoid collisions when multiple SVGs load on the same page
				const instanceId = Math.random().toString(36).slice(2, 8);
				const ids = [];
				svg = svg.replace(/\bid="([^"]+)"/g, (_match, id) => {
					ids.push(id);
					return `id="${instanceId}-${id}"`;
				});
				ids.forEach(id => {
					const escaped = id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
					svg = svg.replace(new RegExp(`url\\(#${escaped}\\)`, 'g'), `url(#${instanceId}-${id})`);
					svg = svg.replace(new RegExp(`href="#${escaped}"`, 'g'), `href="#${instanceId}-${id}"`);
					svg = svg.replace(new RegExp(`xlink:href="#${escaped}"`, 'g'), `xlink:href="#${instanceId}-${id}"`);
				});

				this.outerHTML = svg;
			};
			fetchAndReplaceSvg(this);
		}
	}

	customElements.define('inline-svg', InlineSvg);
}
